module.exports = __webpack_public_path__ + "img/gouwu@2x.2f09afc0.png";